import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CurrentSubscription {
  id: string;
  tenantId: string;
  planCode: string;
  status: string;
  currentPeriodEndUtc: string;
  trialEndsAtUtc: string | null;
  selectedUserCount: number;
  selectedCompanyCount: number;
  finalPrice: number;
}

export interface SubscriptionPlan {
  id: string;
  code: string;
  name: string;
  billingCycle: string;
  basePrice: number;
  currency: string;
  includedUserCount: number;
  includedCompanyCount: number;
  isTrialEligible: boolean;
}

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  private readonly http = inject(HttpClient);

  getCurrentSubscription(): Observable<CurrentSubscription> {
    return this.http.get<CurrentSubscription>(`${environment.apiBaseUrl}/api/v1/subscription/current`);
  }

  listPlans(): Observable<SubscriptionPlan[]> {
    return this.http.get<SubscriptionPlan[]>(`${environment.apiBaseUrl}/api/v1/subscription/plans`);
  }
}
